<template>
  <div>
    <div class="head-nav-fff d-aligncnter d-between">
      <div class="nav-left d-allcenter" @click="pageToBack" style="width: 80px">
        <img src="@/assets/img/appointment/backgrey.svg" style="padding-right: 36px" />
      </div>
      <div class="nav-title d-allcenter overflow" style="width: calc(100% - 160px)">新增预约</div>
      <div class="nav-right fs-xs" @click="showLayer" style="width: 80px; line-height: 44px; color: #009afe">
        《<span class="knew">预约须知</span>》
      </div>
    </div>
    <div class="order" style="padding-bottom: 100px">
      <div class="form-each d-aligncnter">
        <div class="fs-sm label">日期</div>
        <div class="squre-box d-allcenter" @click="preDate">
          <img class="img-size-16" src="@/assets/img/appointment/leftback.svg" />
        </div>
        <!-- <input class="choseDate" v-model="orderData.date" disabled="" @click.stop="showDate" /> -->
        <div style="margin: 0 8px">
          <el-date-picker
            v-model="orderData.date"
            type="date"
            placeholder="选择日期"
            :clearable="false"
            :picker-options="pickerOptions"
            style="width: calc(100vw - 200px)"
            @focus="forbid"
            @change="orderDateChange"
          >
          </el-date-picker>
        </div>
        <!-- <img class="calendarImg" src="@/assets/img/appointment/calendar.svg" @click.stop="showDate" /> -->
        <div class="squre-box d-allcenter right-box" @click="nextDate">
          <img class="img-size-16" src="@/assets/img/appointment/leftback.svg" />
        </div>
        <div class="squre-box d-allcenter" @click="freshData">
          <img class="img-size-16" src="@/assets/img/appointment/refresh.svg" />
        </div>
        <!-- <u-calendar
          :show="show"
          :maxDate="maxDate"
          :defaultDate="orderData.date"
          @confirm="dateConfirm"
          @close="dateClose"
          color="#339571"
        /> -->
        <!-- <el-date-picker v-model="orderData.date" type="date" placeholder="选择日期"> </el-date-picker> -->
      </div>
      <div class="d-aligncnter mt-16">
        <div class="fs-sm label">场馆</div>
        <el-select
          v-model="orderData.stadium.id"
          placeholder="请选择"
          @change="venuseChange($event)"
          style="width: calc(100% - 40px)"
        >
          <el-option
            v-for="item in venuesData"
            :key="item.venueId"
            :label="item.venueName"
            :value="item.venueId"
            popper-class="popper-scrollbar-show"
          >
          </el-option>
        </el-select>
      </div>
      <div class="d-aligncnter mt-16">
        <div class="fs-sm label">场地</div>
        <el-select
          v-model="orderData.site.id"
          placeholder="请选择"
          @change="siteChange($event)"
          style="width: calc(100% - 40px)"
        >
          <el-option v-for="item in sites" :key="item.areaId" :label="item.areaName" :value="item.areaId"> </el-option>
        </el-select>
      </div>

      <!-- <el-select v-model="value" placeholder="请选择">
        <el-option v-for="item in venuesData" :key="item.venueId" :label="item.venueName" :value="item.venueId">
        </el-option>
      </el-select> -->
      <!-- <div class="chose d-flex mt-8">
        <div class="fs-sm label" style="margin-top: 18px">校区</div>
        <div class="options" style="width: calc(100% - 36px)">
          <div
            class="chose-label fs-sm overflow"
            v-for="(item, index) in venuesData"
            :key="index"
            :class="{ green: item.campusName == orderData.campus.name }"
            @click="choseCampus(item)"
          >
            {{ item.campusName }}
          </div>
        </div>
      </div>
      <div class="chose d-flex mt-8" v-show="!!orderData.campus.name">
        <div class="fs-sm label" style="margin-top: 18px">场馆</div>
        <div class="options" style="width: calc(100% - 36px)">
          <div
            class="chose-label fs-sm overflow"
            v-for="(item, index) in stadiums"
            :key="index"
            :class="{ green: item.venueName == orderData.stadium.name }"
            @click="choseStadiums(item)"
          >
            {{ item.venueName }}
          </div>
        </div>
      </div>
      <div class="chose d-flex mt-8" v-show="!!orderData.stadium.name">
        <div class="fs-sm label" style="margin-top: 18px">场地</div>
        <div class="options" style="width: calc(100% - 36px)">
          <div
            class="chose-label fs-sm overflow"
            v-for="(item, index) in sites"
            :key="index"
            :class="{ green: item.areaName == orderData.site.name }"
            @click="choseSites(item)"
          >
            {{ item.areaName }}
          </div>
          <div v-if="sites.length == 0" class="fs-xs d-allcenter" style="margin-top: 16px; width: 100%; color: #888">
            暂未开放预约场地,请切换场馆
          </div>
        </div>
      </div> -->

      <div class="chose-tips fs-xs grey" v-show="!!orderData.site.name">选择您要的预约时间卡片，每次只能选1片。</div>

      <div class="table-set mt-16" v-if="!!orderData.site.id" style="position: relative; padding-left: 40px">
        <div class="d-column" style="position: absolute; left: 4px; font-size: 12px; top: 2.5px">
          <div
            class="d-allcenter"
            v-for="(time, index) in timeData"
            :key="'left_' + index"
            style="height: 39px; color: #8b8b8b"
            :class="{
              'time-green': (currColumnIndex + 1 == index || currColumnIndex == index) && currColumnIndex != -1,
            }"
          >
            {{ time.name }}
          </div>
        </div>
        <!-- <div class="d-column" style="position: absolute; left: 36px; font-size: 12px; top: 2.5px; color: #d1d1d1">
          <div class="d-allcenter" v-for="(time, index) in timeData" :key="'left_' + index + time" style="height: 39px">
            -
          </div>
        </div> -->
        <table class="time-table fs-xs" :style="{ width: getCurrWidth }">
          <tr class="table-top-title">
            <!-- <td class="first-td">
              <div>时间段</div>
            </td> -->
            <td
              v-for="(item, index) in currSets"
              :key="index + 'test' + item.id"
              :style="{ width: getCurrTdWidth }"
              :class="{ noBorder: index == currSets.length - 1 }"
              style="border-right: 1px solid #fff; height: 20px; color: #8b8b8b"
            >
              {{ item.blockName }}
            </td>
          </tr>
          <tr class="can-chose-tr" v-for="(time, index) in timeData" :key="time.id">
            <!-- <td class="first-td">
              <div>{{ time.name }}</div>
            </td> -->
            <template v-if="index < timeData.length - 1">
              <td
                class="center-td"
                style="position: relative"
                v-for="(set, setIndex) in currSetsTest[index].setStatus"
                :key="set.id"
                @click="choseCurrTd(index, setIndex, set)"
                :class="{
                  'left-b': setIndex == 0,
                  currChoose: index == currColumnIndex && setIndex == currLineIndex,
                  tdOccupy: set.state == '已支付' || set.state == '未支付',
                  tdDisabled: set.state == '不可预约',
                  hasClass: set.state == '上课',
                  hasEx: set.state == '训练',
                  lefthg: setIndex == 0,
                  lefthgfir: setIndex == 0 && index == 0,
                }"
              >
                <div v-if="set.state == '上课'" style="color: #fff">上课</div>
                <div v-else-if="set.state == '训练'" style="color: #fff">训练</div>
                <!-- <div v-else-if="set.state == '已支付' || set.state == '未支付'" style="color: #fff">已被预约</div> -->
                <div
                  v-else-if="set.state == '不可预约' || set.state == '已支付' || set.state == '未支付'"
                  style="color: #fff"
                >
                  占用
                </div>
                <!-- <img
                  v-else-if="set.state == '不可预约'"
                  class="img-size-16"
                  src="@/assets/img/appointment/order-close.svg"
                /> -->
                <img
                  v-else-if="index == currColumnIndex && setIndex == currLineIndex"
                  class="img-size-16"
                  src="@/assets/img/appointment/order-check.svg"
                />
                <div v-else style="color: #8b8b8b" class="fs-xs">
                  <div v-if="set.mode">￥{{ set.price }}/人</div>
                  <div v-else>￥{{ set.price }}/场</div>
                </div>
              </td></template
            >
          </tr>
          <tr class="table-bottom-title">
            <!-- <td class="first-td">
              <div>时间段</div>
            </td> -->
            <td
              v-for="(item, index) in currSets"
              :key="item.id"
              :style="{ width: getCurrTdWidth }"
              :class="{ noBorder: index == currSets.length - 1 }"
              style="border-right: 1px solid #fff; height: 20px; color: #8b8b8b"
            >
              {{ item.blockName }}
            </td>
          </tr>
        </table>
      </div>
    </div>
    <!-- <div class="d-flex need d-aligncnter">
      <el-checkbox v-model="mustCheck">已阅读并同意</el-checkbox>
      <div class="fs-sm d-flex">
        <div class="knew" @click="showLayer">预约须知</div>
      </div>
    </div>

    <div class="mt-16 mb-16" style="width: 174px; margin-left: calc(50% - 87px); height: 100px">
      <el-button @click="addOrder" class="my-btn">预约</el-button>
    </div> -->
    <div class="d-between bottom-sub d-aligncnter" v-if="currColumnIndex != -1 && currLineIndex != -1">
      <div style="font-size: 14px; height: 48px" class="d-aligncnter">
        <div>
          <img style="width: 24px" src="@/assets/img/appointment/order-check.svg" />
        </div>
        <div>
          <div>{{ orderData.stadium.name }}{{ orderData.site.name }}</div>
          <div>
            {{ formatDate(orderData.date) }}
            {{ currSetsTest[currColumnIndex].setStatus[currLineIndex].timeInterval }}
          </div>
        </div>
      </div>
      <div class="submit d-allcenter" style="white-space: nowrap" @click="orderChoseOk">
        <span style="font-size: 12px; font-weight: 400">￥</span
        ><span
          >{{ currSetsTest[currColumnIndex].setStatus[currLineIndex].price
          }}<span v-if="currSetsTest[currColumnIndex].setStatus[currLineIndex].mode">/人</span
          ><span v-else>/场</span></span
        >
        <span style="margin-left: 8px">选好了</span>
      </div>
    </div>
    <el-dialog title="预约须知" :visible.sync="needshow" width="80%">
      <div class="need-content fs-xs font-0" v-html="instructionsBook"></div>
    </el-dialog>
  </div>
</template>
<script>
import { Message } from 'element-ui'
import { getOptions, getVenueOrderOpen, commitConference, getInstructionsBook } from '@/api/api-venueOrder'
export default {
  components: {},
  data() {
    return {
      show: false,
      timeshow: false,
      needshow: false,
      title: '场馆预约',
      currBgColor: '#fff',
      leftImg: '',
      routeQuery: '',
      orderData: {
        date: '',
        time: '',
        campus: {
          id: '',
          name: '',
        },
        stadium: {
          id: '',
          name: '',
        },
        site: {
          id: '',
          name: '',
        },
      },
      campus: [
        // "南校区", "北校区", "xx校区"
      ],
      stadiums: [
        // "田径场", "风雨操场"
      ],
      stadiumsIndex: '',
      sites: [
        // "羽毛球", "篮球场", "网球场"
      ],
      minDate: '',
      maxDate: '',
      mustCheck: false,
      schoolSites: [
        // "请选择场馆", "羽毛球馆", "篮球场", "网球场", '足球场', '排球场'
      ],
      siteIndex: 0,
      layerType: 'tips',
      timeData: [
        { id: 0, name: '06:00-07:00' },
        { id: 1, name: '07:00-08:00' },
      ], //时间段
      currSets: [
        { blockName: '1号场', blockId: 1 },
        { blockName: '2号场', blockId: 2 },
      ], //片场数据
      currLineIndex: -1,
      currColumnIndex: -1,
      venuesData: [
        // { campusName: '南校区', venues: [{ venueName: '风雨操场', areas: [{ areaName: '乒乓球1号场' }] }] },
        // { campusName: '北校区', venues: [{ venueName: '篮球场', areas: [{ areaName: '篮球场1号场' }] }] },
        { venueName: '风雨操场', venueId: '1', areas: [{ areaName: '乒乓球1号场', areaId: '2' }] },
      ], //校区、场馆、场地父子关系对象
      reservationNotice: '',
      refreshTime: 0,
      xqLoading: true,
      placeList: [],
      pickerOne: false,
      pickerTwo: false,
      pickerThree: false,
      currSetsTest: [
        {
          timeInterval: '06:00-07:00',
          setStatus: [
            {
              areaName: '排球场',
              blockId: 3,
              blockName: '3号场',
              isChargeStudent: false,
              isChargeTeacher: false,
              setStatus: null,
              state: '可预约',
              timeInterval: '06:00-07:00',
            },
            {
              areaName: '排球场',
              blockId: 3,
              blockName: '3号场',
              isChargeStudent: false,
              isChargeTeacher: false,
              setStatus: null,
              state: '已支付',
              timeInterval: '06:00-07:00',
            },
          ],
        },
        {
          timeInterval: '06:00-07:00',
          setStatus: [
            {
              areaName: '排球场',
              blockId: 3,
              blockName: '3号场',
              isChargeStudent: false,
              isChargeTeacher: false,
              setStatus: null,
              state: '可预约',
              timeInterval: '06:00-07:00',
            },
            {
              areaName: '排球场',
              blockId: 3,
              blockName: '3号场',
              isChargeStudent: false,
              isChargeTeacher: false,
              setStatus: null,
              state: '可预约',
              timeInterval: '06:00-07:00',
            },
          ],
        },
      ],
      instructionsBook: '',
    }
  },
  created() {
    // this.maxDate = this.$getDate.getNextDate(this.$getDate.getToday(), 3)

    let getMyDate = new Date()
    this.orderData.date = getMyDate.getTime()
    this.minDate = new Date(new Date().getTime() - 24 * 60 * 60 * 1000)
    this.maxDate = new Date(new Date().getTime() + 24 * 60 * 60 * 1000 * 4)

    this.getOptionsData()
    this.getInstructionsBookData()
  },
  computed: {
    getCurrWidth() {
      let mywidth = ''
      if (this.currSets.length > 5) {
        mywidth = 22 + 16 * this.currSets.length
      }
      return mywidth + 'vw'
    },
    getCurrTdWidth() {
      let tdwidth = ''
      if (this.currSets.length > 5) {
        tdwidth = 16
      } else {
        tdwidth = 78 / this.currSets.length
      }
      return tdwidth + 'vw'
    },
    pickerOptions() {
      const today = new Date() // 获取今天的日期对象
      const maxDate = new Date(today.getTime() + 24 * 60 * 60 * 1000 * 3) // 将今天的日期对象加上3天得到最大日期
      //   const minDate = new Date(today.getTime())
      return {
        disabledDate(time) {
          const today = new Date()
          if (time < today.getTime() - 24 * 60 * 60 * 1000) {
            return true
          }
          return time > maxDate // 返回true表示该日期不可选
        },
      }
    },
  },
  methods: {
    getInstructionsBookData() {
      getInstructionsBook().then((res) => {
        if (res.data.statusCode == 1) {
          this.instructionsBook = res.data.obj.instructionsBook
        } else {
          Message.error(res.data.message)
        }
      })
    },
    freshData() {
      this.getVenueOrderOpenData()
    },
    pageToBack() {
      this.$router.go(-1)
    },
    venuseChange(e) {
      //   console.log('e:', e)
      let currVenuse = this.venuesData.find((item) => {
        console.log('item:', item)
        return item.venueId === e
      })
      console.log('currVenuse:', currVenuse)
      this.orderData.stadium.id = currVenuse.venueId
      this.orderData.stadium.name = currVenuse.venueName
      //   console.log('e:', this.orderData)
      this.sites = currVenuse.areas
      this.orderData.site.id = ''
      this.currColumnIndex = -1
      this.currLineIndex = -1
    },
    siteChange(e) {
      console.log('currSite:', e)
      let currSite = this.sites.find((item) => {
        console.log('item:', item)
        return item.areaId === e
      })
      console.log('currSite:', currSite)

      this.orderData.site.name = currSite.areaName
      this.currColumnIndex = -1
      this.currLineIndex = -1
      this.getVenueOrderOpenData()
    },
    choseCampus(item) {
      this.currColumnIndex = -1
      this.orderData.campus.name = item.campusName
      this.orderData.campus.id = item.campusId
      this.stadiums = item.venues
      this.orderData.stadium.name = ''
      this.orderData.site.name = ''
      this.orderData.stadium.id = ''
      this.orderData.site.id = ''
    },
    choseStadiums(item) {
      console.log(item)
      this.currColumnIndex = -1
      this.orderData.stadium.name = item.venueName
      this.orderData.stadium.id = item.venueId
      this.sites = item.areas
      this.orderData.site.name = ''
      this.orderData.site.id = ''
    },
    choseSites(item) {
      console.log(item)
      this.currColumnIndex = -1
      this.orderData.site.name = item.areaName
      this.orderData.site.id = item.areaId
      this.getVenueOrderOpenData()
    },
    getVenueOrderOpenData() {
      this.timeData = []
      this.currSets = []
      this.currSetsTest = []
      getVenueOrderOpen(this.formatDate(this.orderData.date), this.orderData.site.id).then((res) => {
        if (res.data.statusCode == 1) {
          console.log('getVenueOrderOpen:', res)
          this.timeData = res.data.obj.venueTimeResList
          this.currSets = res.data.obj.blocks
          this.currSetsTest = res.data.obj.openRes
          if (this.orderData.site.id == '') {
            Message.success('已刷新')
          } else {
            Message.success('已加载')
          }
        } else {
          Message.error(res.data.message)
        }
      })
    },
    choseCurrTd(index, setIndex, set) {
      console.log(index, setIndex, set)
      if (set.state == '可预约') {
        if (this.currColumnIndex == index && this.currLineIndex == setIndex) {
          this.currColumnIndex = -1
          this.currLineIndex = -1
        } else {
          this.currColumnIndex = index
          this.currLineIndex = setIndex
        }

        console.log('1:' + this.currColumnIndex)
        console.log('2:' + this.currLineIndex)
      } else {
        Message.error('该片场' + set.state + '，请空闲选择场地')
      }
    },
    orderChoseOk() {
      localStorage.setItem('friendlist', [])
      this.addOrder()
    },
    addOrder() {
      if (this.currColumnIndex == -1) {
        Message.error('请选择片场！')
      } else {
        // if (this.mustCheck) {
        //   Message.success('ok')
        //   MessageBox.confirm(
        //     `确定预约时间： ` +
        //       this.formatDate(this.orderData.date) +
        //       this.timeData[this.currColumnIndex].name +
        //       ` 预约场地： ` +
        //       this.orderData.campus.name +
        //       this.orderData.stadium.name +
        //       this.orderData.site.name +
        //       `注意事项：`,
        //     '预约信息确认',
        //     {
        //       confirmButtonText: '确定',
        //       cancelButtonText: '取消',
        //     }
        //   )
        //     .then(() => {
        //       console.log('预约')
        //     })
        //     .catch(() => {
        //       console.log('取消')
        //     })

        //   this.$router.push({ path: '/appointment/ordersubmit' })
        console.log('getItem', localStorage.getItem('userId'))
        console.log('getItem', this.currSetsTest[this.currColumnIndex].setStatus[this.currLineIndex])
        const userId = localStorage.getItem('userId')
        const orderOpenId = this.currSetsTest[this.currColumnIndex].setStatus[this.currLineIndex].orderOpenId

        const loading = this.$loading({
          lock: true,
          text: '疯狂预定中',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)',
        })
        commitConference(orderOpenId, userId).then((res) => {
          loading.close()
          if (res.data.statusCode == 1) {
            console.log('res:', res)
            this.$router.push({ path: '/appointment/ordersubmit', query: { conferenceId: res.data.obj.conferenceId } })
          } else {
            Message.error(res.data.message)
          }
        })
        // } else {
        //   Message.error('请阅读勾选预约须知')
        // }
      }
    },
    showLayer() {
      this.needshow = true
    },
    preDate() {
      if (this.minDate < this.orderData.date - 24 * 60 * 60 * 1000) {
        this.orderData.date = this.orderData.date - 24 * 60 * 60 * 1000
        this.currColumnIndex = -1
        this.currLineIndex = -1
        this.getVenueOrderOpenData()
      } else {
        Message.error('不可预约往日')
      }
    },
    nextDate() {
      console.log('this.maxDate:', this.maxDate)
      if (this.maxDate > this.orderData.date + 24 * 60 * 60 * 1000) {
        this.currColumnIndex = -1
        this.currLineIndex = -1
        this.orderData.date = this.orderData.date + 24 * 60 * 60 * 1000
        this.getVenueOrderOpenData()
      } else {
        Message.error('仅可提前3天预约')
      }
    },
    orderDateChange() {
      this.currColumnIndex = -1
      this.currLineIndex = -1
      this.getVenueOrderOpenData()
    },
    formatDate(date) {
      var dateObj = new Date(date)
      var year = dateObj.getFullYear().toString()
      var month = (dateObj.getMonth() + 1).toString().padStart(2, '0')
      var day = dateObj.getDate().toString().padStart(2, '0')
      var formattedDate = `${year}-${month}-${day}`
      return formattedDate
    },
    forbid() {
      document.activeElement.blur()
      this.$nextTick(() => {
        let inputTime = document.querySelectorAll('.el-input__inner')
        inputTime.forEach((item) => {
          item.addEventListener('focus', () => {
            document.activeElement.blur()
          })
        })
      })
    },
    getOptionsData() {
      getOptions().then((res) => {
        if (res.data.statusCode == 1) {
          console.log('res:', res)
          this.venuesData = res.data.obj
        }
      })
    },
  },
}
</script>
<style lang="scss" scoped>
@import '@/assets/css/appoint.scss';
td {
  word-break: break-all;
}
.order {
  width: calc(100% - 32px);
  padding: 0 16px;
  margin-top: 52px;
}

.order-time {
  // display: grid;
  // grid-template-columns: repeat(auto-fill, 50%);
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;

  .form-each {
    width: calc(50% - 8px);
  }

  position: relative;
}

.form-each {
  width: calc(100% - 0px);
  position: relative;
  // margin-top: 16px;

  input {
    width: calc(100% - 160px);
    height: 36px;
    border: 1px solid #007a4d;
    border-radius: 4px;
    // margin-top: 8px;
    outline-style: none;
    margin: 0 4px;
  }
}

.label {
  width: 36px;
}

.chose-label {
  width: calc(50% - 8px);
  overflow: hidden;
  // border: 1px solid #cce4db;
  background: #e8e8e8;
  color: #2f2f2f;
  border-radius: 4px;
  margin-top: 8px;
  height: 36px;
  line-height: 36px;
  text-indent: 8px;
  //   float: left;
  //   margin-right: 16px;
}

.chose {
  // margin-top: 8px;
  // .label {
  //   width: 100%;
  // }
  .options {
    // display: grid;
    // grid-template-columns: repeat(auto-fill, 50%);
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;

    .chose-label {
      width: calc(50% - 8px);
      // margin-right: 8px;
    }
  }
}

.green {
  // border: 1px solid #007a4d;
  background: #339571;
  color: #fff;
}

.grey {
  border: 1px solid #cce4db;
  color: #8b8b8b;
}

.my-btn {
  width: calc(100% - 32px);
  margin-left: 16px;
  height: 56px;
  border: none;
  border-radius: 52px;
  color: #fff;
  background: linear-gradient(270deg, #2f2f2f 0%, #464646 100%), linear-gradient(270deg, #007a4d 0%, #1a875f 100%);
  margin-top: 16px;
  line-height: 56px;

  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: 24px;
    height: 24px;
  }
}

.tips {
  color: #de3831;
  margin-top: 16px;
  margin-left: 16px;
}

.choseDate {
  color: #2f2f2f;
  text-indent: 8px;
}

.calendarImg {
  width: 20px;
  height: 20px;
  position: absolute;
  top: 10px;
  right: 98px;
}

.need {
  margin-top: 20px;
  margin-left: 16px;
}

.knew {
  color: #009afe;
  text-decoration: underline;
}

.shadow {
  width: 100vw;
  height: 100vh;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: #181818;
  opacity: 0.6;
  z-index: 999;
}

.need-title {
  width: 100%;
  text-align: center;
  // margin-bottom: 8px;
}

.need-content {
  // width: 311px;
  // // height: 505px;
  // background: #ffffff;
  // border-radius: 4px;
  // position: absolute;
  // top: 60px;
  // left: calc(50vw - 172px);
  // padding: 16px;
  // z-index: 1000;
  // line-height: 18px;

  width: calc(100% - 24px);
  margin-left: 12px;
  margin-bottom: 16px;
}

.close-btn {
  width: 64px;
  height: 44px;
  background: linear-gradient(270deg, #464646 0%, #5d5d5d 100%);
  border-radius: 52px;
  position: absolute;
  bottom: -60px;
  border: none;
  left: 125px;
  color: #fff;
}
.time-green {
  color: #007a4d !important;
  font-weight: 600;
}
.sitePicker {
  width: 100%;
  height: 36px;
  border: 1px solid #007a4d;
  border-radius: 4px;
  text-indent: 10px;
  line-height: 36px;
}

.squre-box {
  width: 36px;
  height: 36px;
  background: #339571;
  border-radius: 4px;
}

.right-box {
  margin-right: 4px;
  transform: rotate(180deg);
}

.chose-tips {
  background: #e6f2ed;
  border-radius: 4px;
  padding: 4px;
  text-align: center;
  margin-top: 16px;
}

.table-set {
  //   border: 1px solid #d1d1d1;
  border-radius: 4px;
  overflow-x: scroll;

  .time-table {
    border-collapse: collapse;
    border-spacing: 0;

    td {
      height: 36px;
      text-align: center;
      width: 16vw;
    }

    .first-td {
      width: 22vw;
      position: sticky;
      left: 0px;
      background: #fff;
      z-index: 99;
      // border-right: none !important;
      div {
        // background: #EDEDED;
        width: calc(100% + 1px);
        height: calc(100% + 2px);
        margin-top: -1px;
        padding: 0;
        border-right: 1px solid #d1d1d1;
        // line-height: 36px;
        // line-height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }

    .can-chose-tr td,
    .table-top-title td {
      border-bottom: 1px solid #d1d1d1;
      border-right: 1px solid #d1d1d1;
    }

    .table-bottom-title td {
      border-right: 1px solid #d1d1d1;
    }

    .center-td {
      //   background: #e8e8e8;
      background: #f9f9f9;
    }
    .left-b {
      border-left: 1px solid #d1d1d1;
    }

    .noBorder {
      border-right: none !important;
    }

    .currChoose {
      background: #339571;
    }

    .tdOccupy {
      background: #eb8883;
    }

    .tdDisabled {
      //   background: #a3a3a3;
      background: #eb8883;
    }

    .tdNotPay {
      background: #eb8883;
    }
  }
}
.mt-16 {
  margin-top: 16px;
}

.need-content ::v-deep img {
  max-width: 65vw !important;
  height: auto;
}

.need-content ::v-deep span {
  font-size: 12px !important;
}

.need-content ::v-deep p {
  font-size: 12px !important;
}
.need ::v-deep .el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #339571;
  border-color: #339571;
}
.need ::v-deep .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #339571;
}
.need ::v-deep .el-checkbox__inner:hover {
  border-color: #339571 !important;
}
.need ::v-deep .el-checkbox__input.is-focus .el-checkbox__inner {
  border-color: #339571 !important;
}
.need ::v-deep .el-checkbox__label {
  padding-top: 2px;
}

.bottom-sub {
  position: fixed;
  bottom: 0;
  left: 0;
  width: calc(100% - 32px);
  height: 48px;
  padding: 16px;
  background: #339571;
  box-shadow: 0px 0px 8px 0px #007a4d inset;
  color: #fff;
}
.submit {
  background: linear-gradient(270deg, #2f2f2f 0%, #464646 100%);
  border-radius: 52px;
  color: #fff;
  width: 100px;
  height: 32px;
  font-size: 14px;
  padding: 8px 16px;
  font-weight: 600;
}
.hasClass {
  background: #1aa4fe !important;
}
.hasEx {
  background: #9419f8 !important;
}
.lefthg::after {
  content: '-';
  position: absolute;
  left: -4px;
  bottom: -7px;
  color: #d1d1d1;
}
.lefthgfir::before {
  content: '-';
  position: absolute;
  left: -4px;
  top: -9px;
  color: #d1d1d1;
}
// .popper-scrollbar-show {
//   .el-scrollbar {
//     > .el-scrollbar__bar.is-vertical {
//       display: block !important;
//     }
//   }
// }
</style>
